import { determineIfCookieConsentRequired } from "../utils/checkForCookieConsent";
import { getCookieConsentValue } from "react-cookie-consent";
import { MixPanelEventReporter } from "./eventReporter";

export const dialogueReporter = (env?: string) =>
  new MixPanelEventReporter(
    "196176698d39d2743cad3bc369c7166c",
    getCookieConsentValue() === "true" || !determineIfCookieConsentRequired(),
    env || "Kahun Dialogue",
  );
